import '@components/common/ckeditor/styles.css';

export const configCkeditor = {
  height: 500,
  width: '100%',
  resize_enabled: true,
  resize_dir: 'both',
  language: 'vi',
  toolbarCanCollapse: true,
  versionCheck: false,
  contentsCss: '/ckeditor-fix.css',
  colorButton_enableMore : true,
  colorButton_colors: '1ABC9C,2ECC71,3498DB,9B59B6,4E5F70,F1C40F,' +
    '16A085,27AE60,2980B9,8E44AD,2C3E50,F39C12,' +
    'E67E22,E74C3C,ECF0F1,95A5A6,DDD,FFF,' +
    'D35400,C0392B,BDC3C7,7F8C8D,999,000',
  colorButton_foreStyle: {
    element: 'span',
    styles: { 'color': '#(color)' },
    overrides: [ {
      element: 'font', attributes: { 'color': null }
    } ]
  },
  colorButton_backStyle: {
    element: 'span',
    styles: { 'background-color': '#(color)' }
  },
  colorButton_enableAutomatic: true,
  colorButton_colorsPerRow: 6,
  filebrowserBrowseUrl: "/browse-image",
  filebrowserUploadUrl: "/browse-image",
  filebrowserUploadMethod: "form",
  colorButton_renderContentColors: true,
  colorButton_historyRowLimit: 1,
  DIALOG_RESIZE_NONE: 0,
  DIALOG_RESIZE_WIDTH: 1,
  DIALOG_RESIZE_HEIGHT: 2,
  DIALOG_RESIZE_BOTH: 3,
  DIALOG_STATE_IDLE: 1,
  DIALOG_STATE_BUSY: 2,
  allowedContent: true,
  extraPlugins: ["justify", "font", "colorbutton", "maximize"],
  image_previewText: ' ',
  removeDialogTabs: 'image:upload',
  toolbar: [
    { name: 'document', items: [ 'Source', '-', 'NewPage', 'Preview', '-', 'Templates' ] },
    { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
    { name: 'editing', items: [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ] },
    { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak' ] },
    '/',
    { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ] },
    { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language' ] },
    { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
    '/',
    { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
    { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
    { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
  ]
}
